import { DSText } from '@vr/ds-react'
import { Controller, useFormContext } from 'react-hook-form'

import { CardIssuanceProps } from './type'
import { Multi } from '@/components/select/multi'

export const CardIssuance = ({ methods, accountKey }: CardIssuanceProps) => {
  const { setValue } = useFormContext()
  return (
    <>
      <Controller
        key={accountKey}
        name='viaDosCartoes'
        control={methods.control}
        rules={{
          required: 'Via é obrigatório'
        }}
        render={({ field: { onChange, value } }) => (
          <Multi
            isMulti={false}
            closeMenuOnSelect={true}
            value={value}
            onChange={selected => {
              onChange(selected)
              setValue('postoDeColeta', null)
              setValue('pickupAddressPointDetails', null)
            }}
            label='Via dos cartões*'
            loadOptions={() =>
              Promise.resolve({
                options: [
                  { label: '1ª via', value: '0' },
                  { label: '2ª via', value: '1' }
                ],
                hasMore: false,
                additional: { page: 1 }
              })
            }
          />
        )}
      />
      {typeof methods.formState.errors.viaDosCartoes?.message === 'string' && (
        <DSText as='span' size='sm' weight='semibold' color='errorLight'>
          {methods.formState.errors.viaDosCartoes.message}
        </DSText>
      )}
    </>
  )
}
